module.exports = __webpack_public_path__ + "img/road_use.772ece5b.svg";